import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { LogIn, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/logo-tecnologie.webp';

export default function Login() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await login(email, password); toast.success('Accesso effettuato'); nav('/account/brand'); }
    catch (err) { toast.error('Credenziali non valide'); }
    finally { setLoading(false); }
  };

  return (
    <div className="tv-gradient-soft min-h-[80vh] py-14">
      <div className="mx-auto max-w-md px-4 sm:px-6">
        <div className="text-center mb-6">
          <img src={logo} alt="Tecnologie" className="h-10 mx-auto" />
          <div className="mt-1 text-[11px] uppercase tracking-widest text-[#0d63b0] font-semibold">Secure Push · Reseller</div>
        </div>
        <Card className="border border-slate-200 p-7">
          <h1 className="text-2xl font-extrabold text-slate-900">Accedi al pannello</h1>
          <p className="mt-1 text-sm text-slate-600">Gestisci il tuo brand e i tuoi push aziendali.</p>
          <form onSubmit={submit} className="mt-5 space-y-4">
            <div>
              <Label>Email</Label>
              <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@azienda.it" className="mt-1" />
            </div>
            <div>
              <Label>Password</Label>
              <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="mt-1" />
            </div>
            <Button type="submit" disabled={loading} className="w-full h-11 bg-[#0d63b0] hover:bg-[#0a4f8f] text-white">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : (<><LogIn className="h-4 w-4 mr-1.5" /> Accedi</>)}
            </Button>
          </form>
          <div className="mt-3 text-center">
            <Link to="/forgot-password" data-testid="login-forgot-password-link" className="text-sm text-[#0d63b0] font-medium hover:underline">
              Password dimenticata?
            </Link>
          </div>
          <div className="mt-5 pt-5 border-t border-slate-100 text-sm text-slate-600 text-center">
            Non hai un account?{' '}
            <Link to="/register" className="font-semibold text-[#0d63b0] hover:underline">Registrati come reseller</Link>
          </div>
        </Card>
      </div>
    </div>
  );
}
